import { SnackbarKey, useSnackbar } from 'notistack';
import Close from '@mui/icons-material/Close';
import { IconButton } from '@mui/material';

export interface SnackbarCloseActionProps {
  snackbarId: SnackbarKey;
}
export const SnackbarCloseAction = ({
  snackbarId,
}: SnackbarCloseActionProps) => {
  const { closeSnackbar } = useSnackbar();
  return (
    <IconButton
      color='inherit'
      onClick={() => {
        closeSnackbar(snackbarId);
      }}
    >
      <Close fontSize='small' />
    </IconButton>
  );
};
